export const LOGIN = "LOGIN"
export const REFRESH_COGNITO_TOKEN = "REFRESH_COGNITO_TOKEN"
export const LOGOUT = "LOGOUT"